import * as React from 'react'
import { useState, MouseEvent } from 'react'

import PhotoPopup from '../components/profile/popups/photoPopup'

import { ProfileState } from '../store/profile/profileTypings'
import { AlbumType, PhotoType } from '../store/commonTypes'

export interface WithPhotoSliderProps {
    openPhoto?: () => void
    profile?: ProfileState
    album?: AlbumType
    type?: string
}

const WithPhotoSlider =
    () =>
    <P extends WithPhotoSliderProps>(Component: React.ComponentType<P>): React.ComponentType<P> => {
        const PhotoSlider = (props: WithPhotoSliderProps) => {
            const [photo, setPhoto] = useState<PhotoType>(null)
            const [first, setFirst] = useState<boolean>(false)
            const [last, setLast] = useState<boolean>(false)

            const checkPosition = (photo: PhotoType) => {
                setFirst(props.album.list.indexOf(photo) === 0)
                setLast(props.album.list.indexOf(photo) === props.album.list.length - 1)
            }

            const changePhoto = (e: MouseEvent | KeyboardEvent | TouchEvent, prev: boolean) => {
                e.stopPropagation()

                const currentPhotoIndex = props.album.list.indexOf(photo)
                const newPhoto = props.album.list[prev ? currentPhotoIndex - 1 : currentPhotoIndex + 1]
                checkPosition(newPhoto)
                setPhoto(newPhoto)
            }

            return (
                <div>
                    <Component {...(props as P)} openPhoto={setPhoto} />
                    {photo && (
                        <PhotoPopup
                            first={first}
                            last={last}
                            photo={photo}
                            changePhoto={changePhoto}
                            onClose={() => setPhoto(null)}
                            type={props.type}
                        />
                    )}
                </div>
            )
        }
        return PhotoSlider
    }

export default WithPhotoSlider
